import React, { useEffect, useState } from "react";
import "./styles.scss";
import { FormHeader, Pagination, AdminNewsCommentCard } from "../../components";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { getLanguage } from "../../utils/environment";
import Scrollbars from "react-custom-scrollbars-2";
import { getNewsByPage } from "../news/service/news.service";

const lan = getLanguage();

const Comments = () => {
  const [viewPointWidth, setViewPointWidth] = useState(0);
  const [viewPointHeight, setViewPointHeight] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [pageNo, setPageNo] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [pageCount, setPageCount] = useState(10);
  const [newsList, setNewsList] = useState([]);

  // scrollbars start
  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);
    window.addEventListener("scroll", handleOnScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      window.removeEventListener("scroll", handleOnScroll);
      window.removeEventListener("resize", updateWindowDimensions);
    };
  }, []);

  const updateWindowDimensions = () => {
    setViewPointWidth(window.innerWidth);
    setViewPointHeight(window.innerHeight);
  };

  const handleOnScroll = () => {
    let scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    let scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    let clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
  };
  // scrollbars end

  const fetchData = async () => {
    try {
      const response = await getNewsByPage(lan, 10, 1);
      console.log("Get news In page: ", response);

      if (response.data) {
        setNewsList(response?.data?.news);
        setPageCount(response?.data?.count);
        setPageNo(1);
      } else {
        setNewsList([]);
        console.log("Data Not Found");
      }
    } catch (error) {
      console.log("Error fetching Category", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onChangePage = async (pageNumber, size) => {
    console.log("onChangePage", pageNumber, size);
    try {
      if (pageNumber !== pageNo || size !== pageSize) {
        let response = await getNewsByPage(lan, size, pageNumber);
        console.log("response next::", response);
        if (response?.data?.news?.length > 0) {
          setNewsList(response?.data?.news);
          setPageNo(pageNumber);
          setPageSize(size);
          setPageCount(response?.data?.count);
          window.scrollTo(0, 0);
        }
      }
    } catch (error) {
      console.log("Error fetching news by page", error);
      setIsLoading(false);
    }
  };

  const onClickRefresh = async (refresh) => {
    if (refresh) {
      setIsLoading(true);
      await fetchData();
      setIsLoading(false);
      return false;
    } else {
      return false;
    }
  };

  return (
    <>
      <div className={"hne-news-comments-wrapper"}>
        <FormHeader
          data={{
            formHeader: "News Comments",
            size: "md-md",
          }}
        />
        <div className={"hne-nc-body-wrapper col-12"}>
          <Scrollbars
            onScroll={handleOnScroll}
            renderView={(props) => (
              <div {...props} style={{ ...props.style, overflowX: "hidden" }} />
            )}
            style={{ height: viewPointHeight - 270 }}
          >
            {Array.isArray(newsList) && newsList?.length > 0 ? (
              newsList?.map((news) => (
                <AdminNewsCommentCard
                  item={news}
                  isUpdate={news?.updates?.length > 0}
                  refresh={onClickRefresh}
                  // onClickEdit={() => {
                  //   dispatch(setNews(news));
                  // }}
                />
              ))
            ) : (
              <div className="error-message">No News Found</div>
            )}
          </Scrollbars>
          <div
            className={
              "d-flex flex-column justify-content-center align-items-center mt-3"
            }
            style={{
              marginBottom: "20px",
              borderTop: "1px solid #e0e0e0",
              paddingTop: "20px",
            }}
          >
            <Pagination
              data={{
                paginationCount: pageCount,
                pageNo: pageNo,
                pageSize: pageSize,
              }}
              onChange={onChangePage}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default withRouter(Comments);
